module.exports = __webpack_public_path__ + "img/circle.png.36653d1.webp";